import { Fragment } from 'react';

export function OurSiteChangesRegularly() {
  return (
    <Fragment>
      We aim to update our site regularly, and may change the content at any time. If the need arises, we may suspend access to our site, or close it indefinitely. Whilst we will use our reasonable endeavours to keep materials and content on our site up-to-date, we do not make any warranties, guarantees or otherwise in respect of this and are under no obligation to update such material and content.
    </Fragment>
  );
}


export default OurSiteChangesRegularly;
